import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (pluginState, action) {
  switch (action.type) {
    case 'STOP_RESIZING':
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        resizeHandlePos: null,
        dragging: null
      });
    case 'SET_RESIZE_HANDLE_POSITION':
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        resizeHandlePos: action.data.resizeHandlePos
      });
    case 'SET_DRAGGING':
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        dragging: action.data.dragging
      });
    case 'SET_LAST_CLICK':
      var lastClick = action.data.lastClick;
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        lastClick: lastClick,
        resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
      });
    default:
      return pluginState;
  }
});